// react
import { useState, useEffect } from "react";
// components
import MechanicApp from "./MechanicApp/MechanicApp";
import SupplierApp from "./SupplierApp/SupplierApp";
// css
import classes from "./MtorApplications.module.css";
// images
import supplierScreen from "../../../assets/images/supplierScreen.png";
import mechanicScreen from "../../../assets/images/mechanicScreen.png";
import mtorApplicationsVector from "../../../assets/images/mtorApplicationsVector.png";

const MtorApplications = () => {
  const [currentSelectedApp, setCurrentSelectedApp] = useState({
    name: "supplierApp",
    image: supplierScreen,
  });

  const mechanicAppClickedHandler = () => {
    setCurrentSelectedApp({ name: "mechanicApp", image: mechanicScreen });
  };

  const supplierAppClickedHandler = () => {
    setCurrentSelectedApp({ name: "supplierApp", image: supplierScreen });
  };

  useEffect(() => {
    document.getElementById("الموردين").onclick = function () {
      supplierAppClickedHandler();
    };

    document.getElementById("مراكز الخدمة").onclick = function () {
      mechanicAppClickedHandler();
    };
  }, []);

  return (
    <section
      className="mt-24 mb-16 grid grid-cols-1 md:grid-cols-2 gap-y-14 md:gap-x-14 relative"
      id="mtorApps"
    >
      <img
        src={mtorApplicationsVector}
        alt="mtor apps vector"
        className="absolute hidden md:block top-16 xl:top-0 left-8 md:left-0 -z-10"
      />
      <div
        className={[
          classes.AppScreenWrapper,
          "h-800",
          "w-4/5",
          "md:w-full",
          "mx-auto",
        ].join(" ")}
      >
        <div className="h-full overflow-hidden rounded-3xl bg-light-blue flex justify-center items-center">
          <div className="relative w-fit">
            <img
              src={currentSelectedApp.image}
              alt="mtor app screen"
              className="w-320 max-w-4/5 h-608 max-h-4/5 relative z-10"
            />
            <div className={`${classes.TopRightCorner}`} />
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <h2 className="text-center md:text-start text-4xl">تطبيقات موتور</h2>
        <div className="mt-16 ml-auto md:ml-16 mr-auto md:mr-0 w-4/5 md:w-auto  p-6 rounded-lg bg-light-gray flex flex-wrap justify-center items-center gap-6">
          <button
            className={[
              "py-2",
              "px-10",
              "md:py-4",
              "md:px-20",
              "whitespace-nowrap",
              "rounded-lg",
              "text-2xl",
              currentSelectedApp.name === "supplierApp"
                ? "text-white bg-dark-blue"
                : "bg-white",
            ].join(" ")}
            onClick={supplierAppClickedHandler}
          >
            تطبيق الموردين
          </button>
          <button
            className={[
              "py-2",
              "px-10",
              "md:py-4",
              "md:px-20",
              "whitespace-nowrap",
              "rounded-lg",
              "text-2xl",
              currentSelectedApp.name === "mechanicApp"
                ? "text-white bg-dark-blue"
                : "bg-white",
            ].join(" ")}
            onClick={mechanicAppClickedHandler}
          >
            تطبيق مراكز الخدمة
          </button>
        </div>
        {currentSelectedApp.name === "mechanicApp" ? (
          <MechanicApp />
        ) : (
          <SupplierApp />
        )}
      </div>
    </section>
  );
};

export default MtorApplications;
